import { Trans, useTranslation } from 'react-i18next';
import classNames from 'classnames';
import IcShield from '@/assets/icons/Shield.svg?react';
import IcCheck from '@/assets/icons/Check.svg?react';
import webidLogo from '@/assets/logo/webid-logo.png';
import atrustLogo from '@/assets/logo/atrust-logo.png';
import styles from './TrustAside.module.scss';

/**
 * Blue "Verified once. Trusted everywhere." panel shown beside the method
 * selection, with a "verified with webID / A-Trust" partner strip.
 */
const TrustAside = () => {
  const { t } = useTranslation(['onboarding']);

  const bullets = [
    'onboarding:kycRedesign.trustAside.bullets.bound',
    'onboarding:kycRedesign.trustAside.bullets.mark',
    'onboarding:kycRedesign.trustAside.bullets.covers',
  ];

  return (
    <div className={styles.wrap}>
      <section className={styles.panel}>
        <span className={styles.eyebrow}>
          <IcShield className={styles.eyebrowIcon} aria-hidden="true" />
          {t('onboarding:kycRedesign.trustAside.eyebrow')}
        </span>
        <h2 className={styles.title}>
          {t('onboarding:kycRedesign.trustAside.title')}
        </h2>
        <p className={styles.desc}>
          {t('onboarding:kycRedesign.trustAside.desc')}
        </p>
        <ul className={styles.list}>
          {bullets.map((key) => (
            <li key={key} className={styles.row}>
              <span className={styles.bullet} aria-hidden="true">
                <IcCheck />
              </span>
              <span className={styles.rowText}>
                <Trans i18nKey={key} components={[<strong key="b" />]} />
              </span>
            </li>
          ))}
        </ul>
      </section>

      <section className={styles.partners}>
        <span className={styles.partnersLabel}>
          {t('onboarding:kycRedesign.trustAside.verifiedWith')}
        </span>
        <div className={styles.partnerGrid}>
          <div className={styles.partner}>
            <span className={styles.partnerLogoBox}>
              <img
                className={classNames(
                  styles.partnerLogo,
                  styles.partnerLogoWebid
                )}
                src={webidLogo}
                alt="WebID"
              />
            </span>
            <span className={styles.partnerRole}>
              {t('onboarding:kycRedesign.trustAside.verifiedWithIdentity')}
            </span>
          </div>
          <div className={styles.partnerSep} aria-hidden="true" />
          <div className={styles.partner}>
            <span className={styles.partnerLogoBox}>
              <img
                className={styles.partnerLogo}
                src={atrustLogo}
                alt="A-Trust"
              />
            </span>
            <span className={styles.partnerRole}>
              {t('onboarding:kycRedesign.trustAside.verifiedWithTrust')}
            </span>
          </div>
        </div>
      </section>
    </div>
  );
};

export default TrustAside;
